<template>
<div class="debug-tool">
  <div class="search-bar1">
    <form class="ib ml4" v-on:submit.prevent>
      <input type="text" class="ib form-control form-control-sm" required
        v-model="state.search.deviceId" placeholder="車載器ID or 車両番号">

      <i class="ib ml2 far fa-clock" @click="setNow('startTs')"></i>
      <input type="text" class="ib form-control form-control-sm" required
        v-model="state.search.startTs" placeholder="期間from">

      <i class="ib ml2 far fa-clock" @click="setNow('endTs')"></i>
      <input type="text" class="ib form-control form-control-sm" required
        v-model="state.search.endTs" placeholder="期間to">

      <button class="btn btn-sm btn-primary ml8" @click="showMTX">
        検索
      </button>
    </form>
    <button class="btn btn-sm btn-info ml8" @click="removeMTX">
      地図クリア
    </button>
    <button class="btn btn-sm btn-info ml8" @click="saveSearchParams"
        :disabled="state.mtxs.length === 0">
      検索条件保存
    </button>
    <select class="ib form-control form-control-sm ml8"
        @change="restoreSearchParams" v-model="state.searchParamsToRestore">
      <option value="">- 検索条件リストア -</option>
      <option v-for="(e, idx) in state.searchParamCandidacies" :key="idx" :value="e">
        {{idx + 1}}. 車載器ID: {{e.deviceId}}
        期間: {{e.startTs}} 〜 {{e.endTs}}
      </option>
    </select>
  </div>
  <p v-if="state.errorMsg" class="text-danger mt4 ml4">
    {{state.errorMsg}}
  </p>
  <div class="result-area1 mt8" v-if="state.mtxs.length > 0">
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link" :class="{active: state.activeTab === 'mtxs'}"
            @click="state.activeTab = 'mtxs'">
          <span class="ib mtx-prefix"></span>MTX情報
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :class="{active: state.activeTab === 'movies'}"
            @click="state.activeTab = 'movies'">
          <div class="ib movie-prefix">
            <span class="icon-movie-file"></span>
            <span class="icon-movie-camera"></span>
          </div>動画情報
        </a>
      </li>
    </ul>
    <div class="tab-content">
      <div class="tab-pane" :class="{active: state.activeTab === 'mtxs'}">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input"
            v-model="state.disp.mtxs" @change="toggleMTXMapDisp"
            id="dbg-top-tool1-disp-mtxs">
          <label class="custom-control-label" for="dbg-top-tool1-disp-mtxs">
            MTX地図表示
          </label>
        </div>
        <div class="custom-control custom-checkbox ml12 mb4">
          <input type="checkbox" class="custom-control-input"
            v-model="state.disp.mtxTimestamps" @change="toggleMTXMapTsDisp"
            id="dbg-top-tool1-disp-mtx-tss" :disabled="!state.disp.mtxs">
          <label class="custom-control-label" for="dbg-top-tool1-disp-mtx-tss">
            時刻表示
          </label>
        </div>
        <div class="mtx-info-container">
          <div><b>車載器ID: {{state.search.searchedDeviceId}}</b></div>
          <p class="mtx-info" v-for="mtx in state.mtxs" :key="mtx.id" :class="{
              'under-calc': !mtx.isPlaceFilled,
              'no-kp': mtx.isPlaceFilled && !mtx.kilopost,
              'yes-kp': mtx.isPlaceFilled && mtx.kilopost,
            }">
            <span class="ib circle"></span>
            <span class="ib mr4">時刻:{{dtFormat(mtx.ts)}}</span>
            <span class="ib mr4">緯度:{{mtx.location.lat}}</span>
            <span class="ib mr4">経度:{{mtx.location.lon}}</span>
            <template v-if="mtx.isPlaceFilled">
              <span v-if="!!mtx.kilopost">
                KP:{{mtx.kilopost.roadName}} {{mtx.kilopost.direction}} {{mtx.kilopost.placeName}} {{mtx.kilopost.kp}}
              </span>
              <span v-else>
                KP:なし
              </span>
            </template>
            <span v-else>
              KP:計算中
            </span>
          </p>
        </div>
      </div>
      <div class="tab-pane" :class="{active: state.activeTab === 'movies'}">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input"
            v-model="state.disp.movies" @change="toggleMovieMapDisp"
            id="dbg-top-tool1-disp-movies">
          <label class="custom-control-label" for="dbg-top-tool1-disp-movies">
            動画情報地図表示
          </label>
        </div>
        <div class="custom-control custom-checkbox ml12 mb4">
          <input type="checkbox" class="custom-control-input"
            v-model="state.disp.movieGeoIndices" @change="toggleMGIMapDisp"
            id="dbg-top-tool1-disp-mgis" :disabled="!state.disp.movies">
          <label class="custom-control-label" for="dbg-top-tool1-disp-mgis">
            動画再生可能箇所地図表示
          </label>
        </div>
        <div class="movie-info-container">
          <div><b>車載器ID: {{state.search.searchedDeviceId}}</b></div>
          <div class="movie-info" v-for="movie in state.movies" :key="movie.id">
            <div>
              <span class="ib mr4">動画ID:{{movie.id}}</span>
              <span class="ib mr4">開始時刻:{{dtFormat(movie.startTs)}}</span>
              <span class="ib mr4">緯度:{{movie.location.lat}}</span>
              <span class="ib mr4">経度:{{movie.location.lon}}</span>
              <span class="ib mr4">動画尺:{{movie.duration}}秒</span>
            </div>
            <div class="section2">
              <ul class="movie-geo-indices">
                <li v-for="gi in movie.movieGeoIndices" :key="gi.id">
                  <span class="ib mr4">経過秒数:{{gi.tsMsecDiff / 1000}}秒</span>
                  <span class="ib mr4">緯度:{{gi.location.lat}}</span>
                  <span class="ib mr4">経度:{{gi.location.lon}}</span>
                  <template v-if="gi.isPlaceFilled">
                    <span v-if="!!gi.kilopost">
                      KP:{{gi.kilopost.roadName}} {{gi.kilopost.direction}} {{gi.kilopost.placeName}} {{gi.kilopost.kp}}
                    </span>
                    <span v-else>
                      KP:なし
                    </span>
                  </template>
                  <span v-else>
                    KP:計算中
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script setup lang="ts">
import { useDebugTool } from './useDebugTool';
import type { DebugToolProps } from 'src/models/top';

const props = defineProps<DebugToolProps>();

const {
  state,
  dtFormat,
  showMTX,
  removeMTX,
  toggleMTXMapDisp,
  toggleMTXMapTsDisp,
  toggleMovieMapDisp,
  toggleMGIMapDisp,
  setNow,
  saveSearchParams,
  restoreSearchParams,
} = useDebugTool(props);
</script>

<style lang="scss" scoped>
.debug-tool {
  .search-bar1 {
    .form-control {
      width: 130px;
    }
    .far.fa-clock {
      cursor: pointer;
    }
  }
  .result-area1 {
    .nav.nav-tabs {
      height : 46px;
      border-bottom: 1px solid #aaaaaa;
      .nav-link {
        cursor: pointer;
        border: 1px solid #aaaaaa;
        border-bottom-color: transparent;
        background-color: #fdfdfd;
      }
    }
    .tab-content {
      background-color: #fdfdfd;
      padding: 8px;
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
    }
    .mtx-prefix {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 10px;
      margin: 0 2px 0 -4px;
      background-color: #bc42f4;
    }
    .movie-prefix {
      vertical-align: middle;
      margin: -4px 3px 0 -4px;
      .icon-movie-file {
        display: block;
        height: 12px;
        width: 9px;
        background-image: url('/static/img/dbg-component-video-file.png');
        background-repeat: no-repeat;
        background-size: contain;
        margin: 0 0 1px 0;
      }
      .icon-movie-camera {
        display: block;
        height: 9px;
        width: 12px;
        background-image: url('/static/img/dbg-component-video-camera.png');
        background-repeat: no-repeat;
        background-size: contain;
        margin: 0 0 0 -1px;
      }
    }
    .mtx-info-container {
      overflow-y: scroll;
      max-height: 480px;

      .mtx-info {
        margin: 4px 0;

        &.under-calc {
          .circle { background-color: #bc42f4; }
        }
        &.no-kp {
          .circle { background-color: #000000; }
        }
        &.yes-kp {
          .circle { background-color: #9de532; }
        }

        .circle {
          width: 10px;
          height: 10px;
          border-radius: 10px;
          margin: 0;
        }
      }
    }
    .movie-info-container {
      overflow-y: scroll;
      max-height: 480px;

      .movie-info {
        margin: 4px 0;
        .section2 {
          margin: 0 0 0 12px;
        }

        .movie-geo-indices {
          list-style: none;
        }
      }
    }
  }
}
</style>
